import { useRef } from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Process from '../components/Process';
import Projects from '../components/Projects';
import StrategyOfferSection from '../components/StrategyOfferSection';
import ContactCard from '../components/ContactCard';

export default function ProcessPage() {
  const contactRef = useRef(null);

  const handleTalkClick = () => {
    contactRef.current?.focusForm?.();
  };

  return (
    <div className="flex min-h-screen flex-col bg-gradient-to-br from-white via-sky-50 to-indigo-100 font-sans text-slate-900">
      <Navbar onTalkClick={handleTalkClick} />

      <main className="flex-1 pt-32">
        <section className="mx-auto max-w-5xl px-6 text-center md:text-left">
          <div className="grid items-center gap-10 md:grid-cols-2">
            <div>
              <p className="text-sm uppercase tracking-[0.2em] text-slate-500">Our methodology</p>
              <h1 className="mt-4 text-4xl font-semibold md:text-5xl">A sprint-based process built to ship and scale</h1>
              <p className="mt-4 text-lg text-slate-600">
                From discovery to optimisation, every engagement follows a tight feedback loop that prioritises speed,
                transparency, and measurable outcomes.
              </p>
              <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={handleTalkClick}
                  className="inline-flex items-center justify-center rounded-full bg-slate-900 px-6 py-3 text-sm font-semibold text-white shadow hover:opacity-90"
                >
                  Discuss your next sprint →
                </button>
                <a
                  href="tel:14374944736"
                  className="inline-flex items-center justify-center rounded-full border border-slate-300 px-6 py-3 text-sm font-semibold text-slate-800 transition hover:bg-white"
                >
                  Talk now: 1‑437‑494‑4736
                </a>
              </div>
            </div>
            <div className="rounded-3xl border border-slate-200 bg-white/80 p-8 shadow-sm backdrop-blur">
              <h3 className="text-xl font-semibold text-slate-900">Why teams love working this way</h3>
              <ul className="mt-4 space-y-3 text-sm text-slate-600">
                <li>• Fast turnarounds with clear ownership and communication</li>
                <li>• Weekly scorecards that tie activity to revenue and pipeline</li>
                <li>• Experimentation frameworks that compound results over time</li>
                <li>• Growth pods that integrate with your internal team and tools</li>
              </ul>
            </div>
          </div>
        </section>

        <Process onTalkClick={handleTalkClick} />

        <Projects onTalkClick={handleTalkClick} />

        <StrategyOfferSection onTalkClick={handleTalkClick} />
      </main>

      <ContactCard ref={contactRef} className="mt-16" />
      <Footer />
    </div>
  );
}
